import Packages from '@components/home/Packages.jsx';

export default function PackagesPage() {
  return (
    <div style={{ paddingTop: '72px' }}>
      <Packages />
    </div>
  );
}
